import { translate } from 'components/Translation';
import StayCurrentPortrait from '@material-ui/icons/StayCurrentPortrait';
import React from 'react';
import { successColor, support2Color, warningColor, whiteColor } from 'assets/jss/material-dashboard-pro-react';
import Phone from '@material-ui/icons/PhoneOutlined';
import Cast from '@material-ui/icons/Cast';
import Wifi from '@material-ui/icons/Wifi';
import PublicIcon from '@material-ui/icons/Public';
import { remoteConfigSelector } from 'redux/modules/settings/remoteConfig/selectors';
import { useSelector } from 'react-redux';
import { isAamaliPlus, isFiberProOn, isMobilePostpaidServiceOn } from 'utils/killswitch';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/services/addNewServiceStyle';
import { BodyM } from 'components/Typography/Typography';
import { getFiberProLabels } from 'redux/modules/dynamicLabels/selectors';

export const services = (isRiyadaCustomer: boolean): types.newServices.ISingleService[] => {
	const remoteConfig = useSelector(remoteConfigSelector);
	const aamaliPlus = isAamaliPlus(remoteConfig);
	const isMobilePostpaidServiceEnabled = isMobilePostpaidServiceOn(remoteConfig);
	const fiberProLabels = useSelector(getFiberProLabels);
	const isFiberPro = isFiberProOn(remoteConfig); // kill switch to hide fbb pro plan
	//@ts-ignore
	const useStyles = makeStyles(styles);
	const classes = useStyles();
	const helperTextAamali = <BodyM customClassName={classes.helperText}>{translate('riyada.customer.only')}</BodyM>;
	const helperTextfbbPro = <BodyM customClassName={classes.helperText}>{fiberProLabels.fiberProAddLabel}</BodyM>;

	return [
		{
			name: translate('mobile'),
			icon: <StayCurrentPortrait style={{ color: whiteColor }} />,
			iconBackgroundColor: support2Color[0],
			id: 'mobile-services-accordion',
			visible: isMobilePostpaidServiceEnabled,
			tiles: [
				{
					name: translate('add.new.services.add.new.postpaid.line'),
					path: 'nama-plans',
					icon: <StayCurrentPortrait style={{ color: support2Color[0] }} />,
					label: '',
					disabled: false,
				},
			],
		},
		{
			name: translate('fixed.services'),
			icon: <Phone style={{ color: whiteColor }} />,
			iconBackgroundColor: successColor[0],
			id: 'fixed-services-accordion',
			visible: true,
			tiles: [
				{
					name: translate('add.new.services.fixed'),
					path: 'fixed',
					icon: <Phone style={{ color: successColor[0] }} />,
					label: '',
					disabled: false,
				},
				// {
				// 	name: translate('add.new.services.isdn'),
				// 	path: 'isdn',
				// 	icon: <Phone style={{ color: blackColors[1] }} />,
				// 	disabled: true,
				// },
				// {
				// 	name: translate('add.new.services.isdn.pri'),
				// 	path: 'isdn-pri',
				// 	icon: <Phone style={{ color: blackColors[1] }} />,
				// 	disabled: true,
				// },
			],
		},
		{
			name: translate('internet'),
			icon: <Cast style={{ color: whiteColor }} />,
			iconBackgroundColor: warningColor[0],
			id: 'internet-services-accordion',
			visible: true,
			tiles: [
				{
					name: isFiberPro ? fiberProLabels.fiberProAddButton : fiberProLabels.fbbAddButton,
					path: 'fiber-pro', // it is redirection path of the tile
					icon: <Wifi style={{ color: warningColor[0] }} />,
					helperText: isFiberPro ? helperTextfbbPro : <></>,
					disabled: false,
				},
				{
					name: translate('add.new.services.add.aamali.plus'),
					helperText: helperTextAamali,
					path: 'aamali-plus',
					icon: <></>,
					hide: !isRiyadaCustomer || !aamaliPlus, //aamaliPlus is used as kill switch to hide the entrypoint for add new microbundle flow, we'll show the tab only when aamaliPlus is true and customer is Riyada.
				},
			],
		},
	];
};
